import { UPDATE_KEYWORD } from "./mutation-types"

export default {
  namespaced: true,
  state: {
    keyword: ""
  },
  mutations: {
    [UPDATE_KEYWORD](state, payload) {
      state.keyword = payload
    }
  }
}
